import { onAuthStateChanged } from "firebase/auth";
import { collection, query, where } from "firebase/firestore";
import { reactive, watch } from "vue";
import firebase from "../../firebase";
import getCollection from "../services/getCollection";
let emails = reactive([]);
onAuthStateChanged(firebase.firebaseAuth, (user) => {
  if (!user) return;
  const query2 = query(
    collection(firebase.db, "emails"),
    where("to", "==", firebase.firebaseAuth.currentUser.email)
  );
  const { error, documents } = getCollection("emails", query2);
  watch(documents, () => {
    emails.length = 0;
    if (!documents.value) return;
    for (let doc of documents.value) {
      emails.push(doc);
    }
  });
});

export const documents = emails;
